import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1d1f58dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "slider-bottom-bar" };
const _hoisted_2 = { class: "pagination" };
const _hoisted_3 = { class: "page-number" };
const _hoisted_4 = {
    key: 0,
    class: "view-mode-button-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedIconButton = _resolveComponent("FriedIconButton");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['slider-bottom-bar-container', _ctx.blockWidthClass, { 'is-sticky': _ctx.isSticky }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_FriedIconButton, {
                    class: "btn-prev",
                    "data-external": "editor-button-slideshow-prev",
                    "aria-label": "Previous slide",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('slide', -1)))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_FriedIcon, { icon: "chevron-left" })
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentSlide + 1 + '/' + _ctx.numOfSlides), 1),
                _createVNode(_component_FriedIconButton, {
                    class: "btn-next",
                    "data-external": "editor-button-slideshow-next",
                    "aria-label": "Next slide",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('slide', 1)))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_FriedIcon, { icon: "chevron-right" })
                    ]),
                    _: 1
                })
            ]),
            (!_ctx.isSmallScreen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_FriedIconButton, {
                        class: _normalizeClass(['grid-view-button', { active: _ctx.isGridView }]),
                        "data-external": "editor-button-slideshow-card-view",
                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('toggle-grid-view', !_ctx.isGridView)))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_FriedIcon, { icon: "card" })
                        ]),
                        _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, { to: _ctx.route }, {
                        default: _withCtx(() => [
                            _createVNode(_component_FriedIconButton, { "data-external": "editor-button-slideshow-lightbox-view" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_FriedIcon, {
                                        icon: _ctx.isLightboxView ? 'arrow-collapse' : 'arrow-expand'
                                    }, null, 8, ["icon"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["to"])
                ]))
                : _createCommentVNode("", true)
        ])
    ], 2));
}
